var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.4em",
    height: "1em",
    viewBox: "0 0 39.572 27.824"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18757"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-youtube",
    d: "M38.745 4.353a4.972 4.972 0 0 0-3.5-3.521C32.16 0 19.786 0 19.786 0S7.412 0 4.326.832a4.972 4.972 0 0 0-3.5 3.521C0 7.46 0 13.94 0 13.94s0 6.48.827 9.587a4.9 4.9 0 0 0 3.5 3.465c3.086.832 15.46.832 15.46.832s12.374 0 15.46-.832a4.9 4.9 0 0 0 3.5-3.465c.827-3.106.827-9.587.827-9.587s0-6.48-.827-9.587ZM15.739 19.824V8.056l10.342 5.884-10.342 5.884Z",
    fill: "#fec968"
  }))));
};
export default SvgYoutube;